import { ISettingsRepository } from "domain/adapter/repository/ISettingsRepository";
import { Locale, Settings } from "common/models";
import LocalStorageRepository from "../common/LocalStorageRepository";
import { config } from "common/config";

export default class SettingsRepository extends LocalStorageRepository<Settings> implements ISettingsRepository {
    constructor() {
        super(`${config.projectName}-settings`);
    }

    getSettings(): Promise<Settings | undefined> {
        return this.get();
    }

    async setSettings(settings: Partial<Settings>): Promise<void> {
        const currentSettings = await this.getSettings();
        return this.set({ ...currentSettings, ...settings });
    }

    async getLocale(): Promise<Locale | undefined> {
        const settings = await this.getSettings();
        return settings?.locale;
    }

    async setLocale(locale: Locale): Promise<void> { // skipcq: JS-0116
        return this.setSettings({ locale });
    }

    async getLastActivityDate(): Promise<Date | undefined> {
        const settings = await this.getSettings();
        const lastActivityDate = settings?.lastActivityDate;
        return lastActivityDate ? new Date(lastActivityDate) : lastActivityDate;
    }

    async setLastActivityDate(): Promise<void> { // skipcq: JS-0116
        const lastActivityDate = new Date();
        return this.setSettings({ lastActivityDate });
    }

    async removeSettings(): Promise<void> { // skipcq: JS-0116
        return this.clear();
    }
}

export const settingsRepository = new SettingsRepository();
